export default "__VITE_ASSET__1002cbd4__"